<app-access-item [icon]="'/assets/icons/user-group.svg'" iconColor="primary" [hideOverflow]="true">
  <app-access-item-header>
    <span>Everyone in</span><b>{{ group().name }}</b>
  </app-access-item-header>
  <app-access-item-body> {{ groupUserCount() }} People </app-access-item-body>
  <app-access-item-cta>
    <app-gallery-share-context
      itemCta
      [currentAccessLevel]="groupAccessLevel()"
      [accessLevels]="groupAccessLevels"
      [mode]="'group'"
      (onChange)="changeGroupAccessLevel($event)"
      [disabled]="!galleryPermissions().can_edit"
      [type]="'gallery'"
    ></app-gallery-share-context>
  </app-access-item-cta>
</app-access-item>
